import type { FaireProductEntity } from "../../entity_types/product";

export const p_psvady4x3f: FaireProductEntity = {
  token: "p_psvady4x3f",
  type: "product",
  name: "Ruben Tee - Anthracite (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/c894f9f22249845968ba8b18f3f72069136b5a4863140bdbb97481b8e41b3019.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/000f5c8b241d878cc2fc9cac92d958c8ba31aefea0fc43f0821e5fb0f4ea6967.jpeg",
    "https://cdn.faire.com/fastly/3e2f358615d63f78b86cf389c2d699081325cad1c54c9a1a10d87a382e88ec08.jpeg",
    "https://cdn.faire.com/fastly/861bb675c1ac52e5518c4c5f8379268f3d42d20d689a70d83337d670e94ad444.jpeg",
    "https://cdn.faire.com/fastly/9727dceefdbb415fc4afd79d5b65015e13b53efec0607828fe52f58e15b7f3b4.jpeg",
    "https://cdn.faire.com/fastly/9e69d6685bc95971dd99b0e4dadd5c85fb7c569903629e42552a87cce6f10531.jpeg",
    "https://cdn.faire.com/fastly/871478e8547edb18bb852062c9a666ea76ec6fb87c6c993c8b8e9b7b08d59822.jpeg",
    "https://cdn.faire.com/fastly/07ff360e0d64578f4255b8fbac856b3ab7ba6bae49bed9227198b22cc40ea534.png"
  ],
  priceDollars: 66.6,
  description: "The Ruben Tee follows a classic, closer-fitting t-shirt shape with a clean line through the body and a set-in shoulder that adapts across different shoulder widths. It sits closer than more relaxed styles while remaining comfortable, creating a balanced, familiar silhouette that works easily on its own or as a base layer.\n\nMade from smooth cotton with a lightweight feel, it wears simply and comfortably with no added texture. Color blocking brings a quiet graphic element to an otherwise minimal piece, keeping it versatile and easy to style. It pairs naturally with denim, skirts, or shorts, and layers easily under cardigans and jackets.\n\n * 100% deadstock Pima cotton \n * Classic, closer fit with a vintage-inspired silhouette \n * Set-in shoulder that adapts across different shoulder widths \n * Lightweight cotton with a smooth, soft feel \n * Designed for warm weather or layering \n * Pairs well with jeans, skirts, or shorts; works on its own or under layers ",
  tags: [],
  msrpDollars: 148,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:30.278Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
